// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__a691f0d0ea4e30c71868","cls2":"Comments-cls2__ae33f7bd20aadb14dabc Comments-cls1__a691f0d0ea4e30c71868"};